import { Component, Input, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { ComponentService } from '../../../services/component.service';
import { TimezoneService, Timezone } from '../../../services/timezone.service';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { tap, filter, debounceTime } from 'rxjs/operators';

@Component({
	selector: 'app-add-to-calendar',
	templateUrl: './add-to-calendar.component.html',
	styleUrls: ['./add-to-calendar.component.scss']
})
export class AddToCalendarComponent implements OnInit, OnDestroy {
	@Input() componentData: any;
	@Input() formHeight: string;
	@Input() pageType: string;
	@Input() componentID: number;
	@Input() urlGlobalRegExp: any;
	@ViewChild('addToCalendarForm', { static: true }) addToCalendarForm: NgForm;
	@ViewChild('nameField', { static: true }) nameField;
	addToCalendarFormSubscription: Subscription;
	submitted: Boolean = false;
	isPreviewPromiseCompleted: Boolean = false;
	previewPromiseSubscription: Subscription;
	startDate: Date;
	startTime: Date;
	startTime2: Date;
	endDate: Date;
	endTime: Date;
	endTime2: Date;
	maxEventLengthDays = 30;
	eventLengthError = false;
	maxEndDate: Date = void 0;
	minEndDate: Date = void 0;
	endBeforeStart = false;
	timezone: string;
	timezones: Array<Timezone>;
	localOffset: number;

	constructor(private comService: ComponentService, private tz: TimezoneService) {}

	ngOnInit() {
		let timeZoneAdjustment =
			this.componentData.config.newapi && !this.componentData.config.event.universal_event_time
				? (Number(new Date().getTimezoneOffset()) + Number(this.componentData.config.event.timezone)) * 60
				: 0;
		this.startDate = new Date((this.componentData.config.event.timestamp + timeZoneAdjustment) * 1000);
		this.startTime = new Date((this.componentData.config.event.timestamp + timeZoneAdjustment) * 1000);
		this.startTime2 = new Date((this.componentData.config.event.timestamp + timeZoneAdjustment) * 1000);
		this.endDate = new Date(
			(this.componentData.config.event.timestamp + timeZoneAdjustment + this.componentData.config.event.duration * 60) * 1000
		);
		this.endTime = new Date(
			(this.componentData.config.event.timestamp + timeZoneAdjustment + this.componentData.config.event.duration * 60) * 1000
		);
		this.endTime2 = new Date(
			(this.componentData.config.event.timestamp + timeZoneAdjustment + this.componentData.config.event.duration * 60) * 1000
		);
		(this.maxEndDate = new Date()).setDate(this.startDate.getDate() + this.maxEventLengthDays);
		this.minEndDate = this.startDate;

		this.timezones = this.tz.getTimezones();
		if (this.componentData.config.newapi) {
			this.componentData.config.event.universal_event_time = this.componentData.config.event.universal_event_time
				? this.componentData.config.event.universal_event_time
				: false;
		}

		this.previewPromiseSubscription = this.comService.isPreviewPromiseCompleted.subscribe(
			(res) => (this.isPreviewPromiseCompleted = res)
		);
		this.addToCalendarFormSubscription = this.addToCalendarForm.valueChanges
			.pipe(
				tap(() => {
					this.comService.updateDisabledSave(
						(this.addToCalendarForm.dirty && this.addToCalendarForm.invalid) || this.nameField.editComponentName
					);
					this.submitted = false;
				}),
				filter((formData) => this.addToCalendarForm.valid && !this.endBeforeStart && !this.eventLengthError),
				debounceTime(1000),
				tap(() => (this.submitted = true))
			)
			.subscribe();
	}

	ngOnDestroy() {
		this.addToCalendarFormSubscription.unsubscribe();
		this.previewPromiseSubscription.unsubscribe();
	}

	brodcastToPreview() {
		this.comService.updateComponentData(this.componentData);
		this.comService.updatePreviewData();
	}

	dateChange() {
		const day = +this.startDate.getDate();
		const month = +this.startDate.getMonth();
		const year = +this.startDate.getFullYear();
		const hours = +this.startTime.getHours();
		const minutes = +this.startTime.getMinutes();

		const UTC = new Date(year, month, day);
		UTC.setHours(hours, minutes);

		let timeZoneAdjustment =
			this.componentData.config.newapi && !this.componentData.config.event.universal_event_time
				? (Number(new Date().getTimezoneOffset()) + Number(this.componentData.config.event.timezone)) * 60
				: 0;

		this.componentData.config.event.timestamp = UTC.getTime() / 1000 - timeZoneAdjustment;
		this.startTime2 = new Date(UTC.getTime());

		const day2 = +this.endDate.getDate();
		const month2 = +this.endDate.getMonth();
		const year2 = +this.endDate.getFullYear();
		const hours2 = +this.endTime.getHours();
		const minutes2 = +this.endTime.getMinutes();

		const UTC2 = new Date(year2, month2, day2);
		UTC2.setHours(hours2, minutes2);

		const timestamp2 = UTC2.getTime() / 1000 - timeZoneAdjustment;
		this.endTime2 = new Date(UTC2.getTime());

		this.componentData.config.event.duration = Math.floor((timestamp2 - this.componentData.config.event.timestamp) / 60);

		this.minEndDate = new Date(this.startDate);
		(this.maxEndDate = new Date(this.startDate)).setDate(this.startDate.getDate() + this.maxEventLengthDays);

		this.eventLengthError = this.componentData.config.event.duration / 60 > 24 * this.maxEventLengthDays ? true : false;

		this.endBeforeStart = timestamp2 < this.componentData.config.event.timestamp ? true : false;

		if (this.eventLengthError || this.endBeforeStart || this.nameField.duplicateName || this.nameField.nameLength) {
			this.comService.updateDisabledSave(true);
		} else {
			this.comService.updateDisabledSave(false);
		}
	}

	hide(elm) {
		setTimeout(() => {
			elm.hide();
		}, 0);
	}
}
